import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_REVIEW } from "./gql";

const useReviewRun = createDefaultMutationHook(RUN_REVIEW);
export const useBulkReviewRun = createBulkMutationHook(RUN_REVIEW);

export default useReviewRun;
